
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-api/deployment-management",
      function () {
        return require("private-next-pages/data-api/deployment-management.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-api/deployment-management"])
      });
    }
  